export default __webpack_public_path__ + "static/media/logo-white.1a2c0be6.png";